// Featured Events upgrade — session/ladder flyers + polymorphic photo gallery.
import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL;

function client() {
  const token = localStorage.getItem('tl_session_token');
  return axios.create({
    baseURL: `${BASE}/api`,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
}

export const eventMediaAPI = {
  // Primary flyer for Court Movement sessions + ladders (kind: 'session' | 'ladder').
  uploadFlyer: (kind, id, file) =>
    client().post(`/events/${kind}/${id}/flyer`, file, { headers: { 'Content-Type': file.type } }),
  deleteFlyer: (kind, id) => client().delete(`/events/${kind}/${id}/flyer`),

  // Additional-photos gallery (all kinds).
  listPhotos: (kind, id) => client().get(`/events/${kind}/${id}/photos`),
  addPhoto: (kind, id, file) =>
    client().post(`/events/${kind}/${id}/photos`, file, { headers: { 'Content-Type': file.type } }),
  reorder: (kind, id, order) => client().patch(`/events/${kind}/${id}/photos/reorder`, { order }),
  deletePhoto: (photoId) => client().delete(`/events/photos/${photoId}`),

  // Feature-on-Home toggle (sessions + ladders).
  setFeatured: (kind, id, featured_on_home, featured_order = null) =>
    client().post(`/events/${kind}/${id}/featured`, { featured_on_home, featured_order }),
};
